import React from 'react';
import { useGlobalState } from '../GlobalState';
import { USER_BOOKING_STEP_ORDER } from '../../index';

import PaymentPage from './PaymentPage';

function UserBookingPaymentPage() {
  const [bookingId] = useGlobalState('bookingId');
  const [fisheryInfo] = useGlobalState('fisheryInfo');
  const [, setCurrent] = useGlobalState('current');
  const [finalPricing] = useGlobalState('finalPricing');
  const [isInsideWidget] = useGlobalState('isInsideWidget');
  const [reservationExpiryTime, setReservationExpiryTime] = useGlobalState(
    'reservationExpiryTime'
  );

  const onPaymentSuccess = () =>
    setCurrent(USER_BOOKING_STEP_ORDER.indexOf('success'));

  const onPaymentFailure = () =>
    setCurrent(USER_BOOKING_STEP_ORDER.indexOf('failure'));

  return (
    <PaymentPage
      idField={{ name: 'booking_public_id', value: bookingId?.public_id }}
      amount={finalPricing}
      enableStoredCards={!isInsideWidget}
      enableApplePay={!isInsideWidget}
      enableSaveCard={!isInsideWidget}
      onPaymentSuccess={onPaymentSuccess}
      onPaymentFailure={onPaymentFailure}
      title={fisheryInfo?.venue_name}
      headerContent={
        <p>
          <span className={'gSemiBold fs-19'}>Booking ID:</span>{' '}
          {bookingId?.public_id}
        </p>
      }
      paymentExpiryTime={reservationExpiryTime}
      onClickCountdownEndedBack={() => {
        setReservationExpiryTime(Date.now());
        setCurrent(0);
      }}
    />
  );
}

export default UserBookingPaymentPage;
